<template>
  <div class="md-layout">
    <div id="objectHeaderContentHidden" style="display: none;">
      <div><md-icon class="icon-color">{{list.pageIcon}}</md-icon></div>
      <div>
        <h1 class="md-title icon-color">{{ $route.name }} </h1>
        <h2 style="visibility: hidden;opacity:0;"></h2>
      </div>
    </div>

    <div class="md-layout-item _notesList">
      <ElasticList :list="list"></ElasticList>
    </div>
  </div>
</template>

<script>
import ElasticList from "@/components/DynamicForm/ElasticList";

export default {
  components: {
    ElasticList
  },
  data() {
    return {
      list: {
        hideNewRecordButton: true,
        hideListHeader: true,
        linkRows: false,
        pageTitle: "Notes",
        pageIcon: "note",
        listQueryId: "searchNotes",
        itemActions: [],
        linkConfigs: [
          {
            name: 'username',
            hrefCallback: (column, name, item) => {
              return item.user ? `#/users/${item.user.id}` : '#';
            },
            titleCallback: (column, name, item) => {
              return item.user ? item.user.given_name + ' ' + item.user.family_name : '';
            },
          },
          {
            name: 'caseSubject',
            hrefCallback: (column, name, item) => {
              return item.case ? `#/cases/${item.case.id}` : '#';
            },
            titleCallback: (column, name, item) => {
              return item.case && item.case.subject ?item.case.subject : '';
            },
          },
        ],
        columns: {
          noteFormatted: { label: "Note", title: 'noteTitle' },
          username: { label: "User" },
          createdAt: { label: "Created", sortable: true },
          updatedAt: { label: "Updated", sortable: false },
          internalFormatted: { label: "Internal" },
          caseSubject: { label: "Case" },
        },
        perPageOptions: [5, 10, 20, 25, 50],
        defaults: {
          sort: 'createdAt',
          sortDir: 'desc',
          perPage: 10,
        },
        fuseSearch: null,
        formatResponse: (data) => {
          let result = [];
          const responseFieldName = 'searchNotes';
          const items = this.$reduce(data, 'searchNotes.items');
          if (items && items.length) {
            items.forEach((_item) => {
              _item.username = _item.user ? _item.user.given_name + ' ' + _item.user.family_name : _item.owner;
              _item.caseSubject = (_item.case && _item.case.subject)? _item.case.subject : '';
              _item.internalFormatted = _item.internal ? 'Yes' : 'No';
              _item.noteFormatted = _item.note ? _item.note.replace(/(<([^>]+)>)/gi, "").substr(0, 180) : '';
              _item.noteTitle = _item.note ? _item.note.replace(/(<([^>]+)>)/gi, "") : '';
              result.push(_item);
            });
          }
          return result;
        }
      },
    };
  },
};
</script>

<style lang="scss">
  ._notesList tbody .md-table-row {
    .md-table-cell:first-child {
      width: 30%;
    }
    .md-table-cell:nth-child(2) {
      width: 20%;
    }
  }
</style>
